// @flow
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import Icon from '@tablekit/icon';
import {
  CLASSIC_COLORS,
  COLORS,
  FONT_WEIGHTS,
  SPACING,
  typography
} from '@tablekit/theme';

export const MenuIcon = styled(Icon)`
  margin-left: ${SPACING.L2};
  transition: transform 0.2s ease-in-out;
  transform: rotate(0);
`;

export const Logo = styled.img`
  display: flex;
  align-self: center;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  transition-property: opacity;
  transition-duration: inherit;
  transition-timing-function: inherit;
  height: 24px;
`;

export const linkStyles = css`
  display: inline-flex;
  cursor: pointer;
  flex: 1 1 auto;
  align-items: center;
  background: none;

  &,
  &:hover,
  &:visited,
  &:active {
    outline: none;
    text-decoration: none;
  }
`;

export const CountryLabel = styled.span`
  margin-left: ${SPACING.L2};
`;

const menuLinkColor = (props) => {
  if (!props.isOpen) {
    return 'currentColor';
  }
  return props.isDark ? CLASSIC_COLORS.primary2 : COLORS.PURPLE.L2;
};

const propForwarding = {
  shouldForwardProp: (prop) => ['isDark', 'isOpen'].indexOf(prop) === -1
};

export const MenuHeader = styled('div', propForwarding)`
  position: relative;
  ${linkStyles};
  font-weight: ${FONT_WEIGHTS.BOLD};
  color: ${menuLinkColor};
  line-height: ${SPACING.L6};
`;

export const MenuItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  white-space: nowrap;

  ${typography('L3')};
  font-weight: ${FONT_WEIGHTS.BOLD};
  color: currentColor;

  margin: 0 ${SPACING.L4};

  &.open ${MenuIcon} {
    transform: rotate(180deg);
  }
`;
